import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DashboardPage } from './pages/DashboardPage';
import { PianificazionePage } from './pages/CalendarioPage';
import { CreditiPage } from './pages/AbbonamentiPage';
import { ProfiloPage } from './pages/SchedaProprietaPage';
import { ImpostazioniPage } from './pages/ImpostazioniPage';
import { RichiestePage } from './pages/PuliziePage';
import { SegnalazioniPage } from './pages/SegnalazioniPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Navigate to="/dashboard" replace data-id="element-3" />} data-id="element-2" />
        <Route path="/dashboard" element={<DashboardPage data-id="element-5" />} data-id="element-4" />
        <Route path="/richieste" element={<RichiestePage data-id="element-7" />} data-id="element-6" />
        <Route path="/pianificazione" element={<PianificazionePage data-id="element-9" />} data-id="element-8" />
        <Route path="/segnalazioni" element={<SegnalazioniPage data-id="element-11" />} data-id="element-10" />
        <Route path="/crediti" element={<CreditiPage data-id="element-13" />} data-id="element-12" />
        <Route path="/profilo" element={<ProfiloPage data-id="element-15" />} data-id="element-14" />
        <Route path="/impostazioni" element={<ImpostazioniPage data-id="element-17" />} data-id="element-16" />

        {/* Redirect old routes just in case */}
        <Route path="/pulizie" element={<Navigate to="/richieste" replace data-id="element-19" />} data-id="element-18" />
        <Route path="/calendario" element={<Navigate to="/pianificazione" replace data-id="element-21" />} data-id="element-20" />
        <Route path="/abbonamenti" element={<Navigate to="/crediti" replace data-id="element-23" />} data-id="element-22" />
        <Route path="/scheda-proprieta" element={<Navigate to="/profilo" replace data-id="element-25" />} data-id="element-24" />
      </Routes>
    </Router>;
}